module.exports = __webpack_public_path__ + "img/bx_bxs-edit-blue.697bed33.svg";